"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoStarSvg = function (_a) {
    var proportion = _a.proportion, size = _a.size, id = _a.id, color = _a.color, type = _a.type;
    // Format score into percentage
    var filledPct = (proportion * 100).toFixed(0);
    // Adjust the fill of score .1 -> .9 to be 20% -> 80%.
    // E.g. .0 ---- 0%
    //      .1 ---- 20%
    //      .2 ---- 27.5%
    //      .3 ---- 35%
    //          ...
    //      .8 ---- 72.5%
    //      .9 ---- 80%
    // in the formula to calculate adjustedPct: 20 = starting point; 7.5 = (80-20)/8;
    var adjustedPct = 20 + 7.5 * (+filledPct / 10 - 1);
    var gradientOffset = +filledPct >= 10 && +filledPct <= 90 ? adjustedPct : filledPct;
    return ((0, preact_1.h)("svg", { width: "17.1190173px", height: "16.2811529px", viewBox: "0 0 17.1190173 16.2811529", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", class: "yotpo-star__img yotpo-star__img--".concat(size) },
        type == 'partial' && ((0, preact_1.h)("defs", null,
            (0, preact_1.h)("linearGradient", { id: id },
                (0, preact_1.h)("stop", { offset: "0%", "stop-color": color }),
                (0, preact_1.h)("stop", { offset: "".concat(gradientOffset, "%"), "stop-color": color }),
                (0, preact_1.h)("stop", { offset: "".concat(gradientOffset, "%"), "stop-color": "#FFF" }),
                (0, preact_1.h)("stop", { offset: "100%", "stop-color": "#FFF" })))),
        (0, preact_1.h)("title", null, "Star"),
        (0, preact_1.h)("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            (0, preact_1.h)("g", { transform: "translate(-110.4405, -425)", stroke: color, fill: type === 'filled' ? color : type === 'partial' ? "url(#".concat(id, ")") : 'none' },
                (0, preact_1.h)("g", { transform: "translate(40, 425)" },
                    (0, preact_1.h)("path", { d: "M79,1.12977573 L81.3130009,5.81642741 L86.4850281,6.56796695 L82.742514,10.2160165 L83.6260018,15.3671452 L79,12.9351121 L74.3739982,15.3671452 L75.257486,10.2160165 L71.5149719,6.56796695 L76.6869991,5.81642741 L79,1.12977573 Z", id: "Star" }))))));
};
exports.default = YotpoStarSvg;
